var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.265137,
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1024 32.5871C34.2782 32.4113 34.5166 32.3125 34.7653 32.3125H49.7653C50.0139 32.3125 50.2524 32.4113 50.4282 32.5871L55.1537 37.3125H29.377L34.1024 32.5871Z",
    fill: "#466AEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8276 39.1875H55.7026V50.75C55.7026 51.2677 55.2829 51.6875 54.7651 51.6875H46.0151C45.7665 51.6875 45.528 51.5887 45.3523 51.4129L42.2651 48.3259L39.178 51.4129C39.0022 51.5887 38.7638 51.6875 38.5151 51.6875H29.7651C29.2474 51.6875 28.8276 51.2677 28.8276 50.75V39.1875ZM33.5151 44.1875H37.2651V42.3125H33.5151V44.1875Z",
    fill: "#466AEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr);
export default __webpack_public_path__ + "static/media/VR.eb7b7bbf8a2d58352a023fac8c00b370.svg";
export { ForwardRef as ReactComponent };